<template>
    <div
        class="px-2 sm:px-10 py-4 relative w-full h-screen flex flex-col flex-1"
    >
        <Header
            :title="content.title"
            :description="content.description"
            :profile="{
                avatar: get(state.currentUser, 'avatar'),
                name:
                    get(state.currentUser, 'firstName', '') +
                    ' ' +
                    get(state.currentUser, 'lastName', ''),
            }"
        />
        <div class="pt-10 flex flex-col flex-1">
            <div class="flex flex-col flex-1">
                <ListViewHeader
                    v-bind="{
                        ...content.ideaHeader,
                        title: `Ideas and Ventures (${ventures?.length})`,
                    }"
                    @onClick="() => (isShowIdea = true)"
                />
                <Loader v-if="isLoading" :isLoading="isLoading" />
                <div
                    v-if="ventures?.length > 0 && !isLoading"
                    class="space-y-3 mt-5"
                >
                    <CardWithBadge
                        v-for="idea in ventures"
                        :key="idea.id"
                        v-bind="idea"
                        @onClick="
                            $router.push({
                                name: 'Venture Dashboard',
                                params: { ventureId: idea.id },
                            })
                        "
                    />
                    <Text
                        @click="$router.push('/ventures')"
                        size="sm"
                        color="primary-600"
                        content="View all"
                        decoration="underline"
                        custom-class="cursor-pointer"
                    />
                </div>
                <EmptyState
                    v-else-if="!isLoading"
                    class="bg-white mt-5"
                    isFull
                    v-bind="content.empty"
                    :action="() => (isShowIdea = true)"
                />
            </div>
        </div>
        <!-- <div class="mt-10">
      <ListViewHeader title="Resources" />
      <div class="space-y-3 mt-5">
        <CardWithImage v-for="idea in resources" :key="idea.id" v-bind="idea" @onClick="() => $router.push({
          name: 'Resource Detail',
          params: { id: idea?.id },
        })
          " />
        <Text size="sm" color="primary-600" content="More Resources" decoration="underline" custom-class="cursor-pointer"
          @click="$router.push('/resources')" />
      </div>
    </div> -->
        <div v-if="companies?.length > 0" class="mt-10">
            <ListViewHeader title="Your Ecosystem" />
            <div class="space-y-3 mt-5">
                <CardWithBadge
                    v-for="idea in companies"
                    :key="idea.id"
                    v-bind="idea"
                />
                <!--					<Text size="sm" color="primary-600" content="More Resources" decoration="underline" custom-class="cursor-pointer"/>-->
            </div>
        </div>
        <WelcomeModal
            :open="isShow"
            :content="c.addIdea"
            v-bind="welcome"
            @onClose="() => onCloseWelcome(false)"
            @onCreateVenture="() => onCloseWelcome(true)"
        />
        <AddIdeaSimple
            v-bind="{
                ...simpleAddIdeaConstants,
                isShow: isShowIdea,
                isLoading: false,
                isSaving: isSaving,
                formList: simpleForm,
                modelKey: 'modelField',
                finalData: formData,
            }"
            @saveForm="(formObject, index, lambdaResponses) => saveForm(formObject, index, lambdaResponses)"
            @onClose="
                () => {
                    isShowIdea = false;
                }
            "
        />
        <EcosystemAcceptModal
            :open="isShowEco"
            @onClose="() => onCloseEco()"
            @onCreateVenture="() => onCreateVenture()"
            :title="`Welcome to ${state.currentUser?.companies?.[0]?.name} - we're glad you are here!`"
            :textHtml="`Which of your idea would you like to use as part of ${state.currentUser?.companies?.[0]?.name}?`"
            :ventures="json(state.venture.ventures)"
            :text="`Sharing an idea with ${state.currentUser?.companies?.[0]?.name} will allow the admins to be able to see and edit your data so they can help you navigate each step of the process.`"
        />
        <WelcomeCohortModal
            :open="isShowCohort"
            @onClose="() => onCloseCohort()"
            @onCreateVenture="() => onCreateVenture()"
            @onNext="connectVenturesToCohort"
            :title="`Welcome to ${state.currentUser?.cohorts?.[0]?.program?.name} - we're glad you are here!`"
            :textHtml="`Which of your idea would you like to use as part of ${state.currentUser?.cohorts?.[0]?.program?.name}?`"
            :ventures="json(state.venture.ventures)"
            :text="`Sharing an idea with ${state.currentUser?.cohorts?.[0]?.program?.name} will allow the admins to be able to see and edit your data so they can help you navigate each step of the process.`"
        />
        <WelcomeEcosystemModal
            :open="isShowEcoWelcome"
            v-bind="welcomeEcosystem"
            @onClose="(isOpen) => onCloseEcoWelcome(isOpen)"
        />
        <SimpleAlert
            :isShow="isShowVenture"
            :title="`You've been added to the venture team <b>${
                state.venture.ventures?.[
                    state.currentUser?.metadata?.recentlyInvitedVentureId
                ]?.name
            }</b>`"
            icon="LightBulbIcon"
            yesBtnText="Go to Venture Team"
            :onYesClick="() => onCloseVentureAlert(true)"
            noBtnText="Cancel"
            :onNoClick="() => onCloseVentureAlert(false)"
            yesBtnVariant="primary"
            noBtnVariant="secondary"
            iconColor="primary"
        />
    </div>
</template>

<script>
import Header from "../components/molecules/PageViewHeader/WithAvatar/WithAvatar";
import EmptyState from "../components/organisms/EmptyState/Simple/Simple";
import ListViewHeader from "../components/molecules/ListViewHeader/WithTitleAndButton/WithTitleAndButton";
import CardWithBadge from "../components/molecules/CardListItem/CardWithBadge/CardWithBadge";
import CardWithImage from "../components/molecules/CardListItem/CardWithImage/CardWithImage";
import Text from "../components/atoms/Text/Text";
import { c } from "../components/constants.js";
import WelcomeModal from "../components/organisms/Modals/Large/Large";
import _, { get, lowerFirst } from "lodash";
import { form } from "../../.storybook/sampleData";
import {
    AddIdeaSimple,
    simpleAddIdeaForm,
    simpleAddIdeaConstants,
} from "../components/flows/AddIdeaSimple";
import EcosystemAcceptModal from "../components/organisms/Modals/EcosystemAcceptModal/EcosystemAcceptModal.vue";
import WelcomeCohortModal from "../components/organisms/Modals/WelcomeCohortModal/WelcomeCohortModal.vue";
import WelcomeEcosystemModal from "../components/organisms/Modals/WelcomeEcosystemModal/WelcomeEcosystemModal";
import SimpleAlert from "../components/organisms/Modals/SimpleAlert/SimpleAlert.vue";
import { json } from "overmind";
import { Settings } from "../../settings";
import Loader from "../components/atoms/Loader/Loader.vue";

export default {
    components: {
        Header,
        EmptyState,
        ListViewHeader,
        CardWithImage,
        CardWithBadge,
        Text,
        WelcomeModal,
        AddIdeaSimple,
        EcosystemAcceptModal,
        WelcomeCohortModal,
        WelcomeEcosystemModal,
        SimpleAlert,
        Loader,
    },
    data() {
        return {
            content: c.home,
            isShow: false,
            isShowIdea: false,
            welcome: c.welcome,
            get,
            c,
            ventures: [],
            resources: [],
            companies: [],
            form,
            simpleForm: simpleAddIdeaForm,
            simpleAddIdeaConstants,
            venture: null,
            formData: {},
            isSaving: false,
            isShowEco: false,
            isShowCohort: false,
            isShowEcoWelcome: false,
            isShowVenture: false,
            welcomeEcosystem: c.welcomeEcosystem,
            json,
            result: null,
            isLoading: false,
        };
    },
    async mounted() {
        $(document).keydown(function (objEvent) {
            if (objEvent.keyCode == 9) {
                //tab pressed
                objEvent.preventDefault(); // stops its action
            }
        });
    },
    async created() {
        this.isLoading = true;
        try {
            this.formData.location = [Settings.usObj];
            await this.getVenturesData();
            let params = this.$route.query;
            if (Object.keys(params)?.length > 0) {
                if (params?.eco && !params?.ch) {
                    this.isShowEco = true;
                } else if (params?.ch) {
                    this.isShowCohort = true;
                } else if (params?.eco && params?.isa) {
                    this.isShowEcoWelcome = true;
                }
                await this.actions.user.inviteUserAction({
                    route: this.$route,
                    user: this.state.currentUser,
                    noAlert: true,
                });
            } else {
                console.log(this.state.currentUser, "current user");
                if (this.state.currentUser?.metadata?.showAdminEcosystemModal) {
                    this.isShowEcoWelcome = true;
                } else if (
                    this.state.currentUser?.metadata?.showEcosystemModal
                ) {
                    this.isShowEco = true;
                } else if (this.state.currentUser?.metadata?.showCohortModal) {
                    if (Object.keys(this.state.venture.ventures)?.length > 0) {
                        this.isShowCohort = true;
                    }
                } else if (this.state.currentUser?.metadata?.firstLogin) {
                    this.isShow = this.state.currentUser?.metadata?.firstLogin;
                } else if (this.state.currentUser?.metadata?.showVentureAlert) {
                    this.isShowVenture = true;
                }
            }
            await this.getResourcesData();
            console.log(this.formData, "formData");
            await this.actions.tag.getTags({
                all: true,
                where: { status: "APPROVED", name_not: "Prefer not to say" },
            });
            const ages = [],
                genders = [],
                incomes = [],
                locations = [],
                ethnicities = [],
                interests = [],
                revenues = [],
                employee_counts = [];
            json(this.state.tag.tags)
                .filter((t) => t.category === "AGE")
                ?.map((t) => {
                    ages.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "GENDER")
                ?.map((t) => {
                    genders.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "INCOME")
                ?.map((t) => {
                    incomes.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.type === "LOCATION")
                ?.map((t) => {
                    locations.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "ETHNICITY")
                ?.map((t) => {
                    ethnicities.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "DESCRIPTORS")
                ?.map((t) => {
                    interests.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "REVENUE")
                ?.map((t) => {
                    revenues.push({ ...t, label: t.name });
                });
            json(this.state.tag.tags)
                .filter((t) => t.category === "EMPLOYEE_COUNT")
                ?.map((t) => {
                    employee_counts.push({ ...t, label: t.name });
                });
            this.form[2].list[1].fields[0].options = JSON.stringify(
                revenues?.sort((a, b) => (a?.sortOrder > b?.sortOrder ? 1 : -1))
            );
            this.form[2].list[2].fields[0].options =
                JSON.stringify(employee_counts);
            this.form[2].list[0].fields[0].options = JSON.stringify(
                interests?.filter((i) => i?.status === "APPROVED")
            );

            this.form[3].list[1].fields[0].options = JSON.stringify(ages);
            this.form[3].list[2].fields[0].options = JSON.stringify(genders);
            this.form[3].list[3].fields[0].options =
                JSON.stringify(ethnicities);
            this.form[3].list[4].fields[0].options = JSON.stringify(incomes);
            this.form[3].list[6].fields[0].options = JSON.stringify(
                revenues?.sort((a, b) => (a?.sortOrder > b?.sortOrder ? 1 : -1))
            );
            this.form[3].list[7].fields[0].options =
                JSON.stringify(employee_counts);
            // this.form[3].list[5].fields[0].options = JSON.stringify(locations);
            this.form[3].list[0].fields[0].options = JSON.stringify(
                interests?.filter((i) => i?.status === "APPROVED")
            );
            await this.actions.actionStep.getActionSteps({ all: true });
            await this.actions.economy.getEconomies({ all: true });
            const economies = [];
            this.state.economy.economies.map((o) =>
                economies?.push({
                    ...o,
                    name: o?.problem,
                    label: o?.problem,
                })
            );
            console.log(economies, "economies");
            const actionSteps = [];
            this.state.actionStep.actionSteps
                ?.filter((a) => a?.status === "APPROVED")
                .map((o) =>
                    actionSteps?.push({
                        ...o,
                        label: o?.name,
                    })
                );
            this.form[4].list[1].fields[0].options =
                JSON.stringify(actionSteps);
            this.form[4].list[2].fields[0].options = JSON.stringify(
                economies?.filter((e) => e?.name)
            );
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        async connectVenturesToCohort(ventures) {
            const list = Object.values(ventures)?.filter((v) => v?.isToggled);
            for (let i = 0; i < list.length; i++) {
                await this.actions.venture.addVentureTo({
                    userId: this.state.currentUser?.id,
                    ventureId: list[i]?.id,
                    cohortId:
                        this.state.currentUser?.metadata
                            ?.recentlyInvitedCohortId,
                });
            }
        },
        async onCloseCohort() {
            this.isShowCohort = false;
            await this.actions.user.saveUser({
                where: { id: this.state.currentUser?.id },
                data: {
                    metadata: {
                        ...this.state.currentUser?.metadata,
                        showCohortModal: false,
                    },
                },
            });
        },
        async onCloseEco() {
            this.isShowEco = false;
            await this.actions.user.saveUser({
                where: { id: this.state.currentUser?.id },
                data: {
                    metadata: {
                        ...this.state.currentUser?.metadata,
                        showEcosystemModal: false,
                    },
                },
            });
        },
        async onCloseVentureAlert(isYes) {
            if (isYes) {
                this.$router.push({
                    name: "Venture Dashboard",
                    params: {
                        ventureId:
                            this.state.currentUser?.metadata
                                ?.recentlyInvitedVentureId,
                    },
                });
            }
            await this.actions.user.saveUser({
                where: { id: this.state.currentUser?.id },
                data: {
                    metadata: {
                        ...this.state.currentUser?.metadata,
                        showVentureAlert: false,
                    },
                },
            });
        },
        async onCloseEcoWelcome(isOpen) {
            try {
                this.isShowEcoWelcome = false;
                this.$router.push({
                    name: "Ecosystem Detail",
                    params: {
                        companyId: this.state.currentUser?.companies?.[0]?.id,
                    },
                });
                await this.actions.user.saveUser({
                    where: { id: this.state.currentUser?.id },
                    data: {
                        metadata: {
                            ...this.state.currentUser?.metadata,
                            firstLogin: false,
                            showAdminEcosystemModal: false,
                            showEcosystemModal: false,
                        },
                    },
                });
            } catch (e) {
                console.log(e);
            }
        },
        onCreateVenture() {
            this.isShowEco = false;
            this.isShowCohort = false;
            setTimeout(() => {
                this.isShowIdea = true;
            }, 500);
            if (this.state.currentUser?.metadata?.showVentureAlert) {
                this.isShowVenture = true;
            }
        },
        async saveForm(data, index, lambdaResponses = null) {
            if (this.isSaving) return false;
            console.log('🏠 saveForm called - data:', data, 'index:', index, 'lambdaResponses:', lambdaResponses);
            console.log('🏠 saveForm call stack:', new Error().stack);
            if (Object.keys(data)?.find((k) => k === "modelField")) {
                delete data.modelField;
            }
            this.isSaving = true;
            try {
                let response = null;
                if (index === 0) {
                    this.formData = { ...data };
                } else if (index === 1) {
                    this.formData = { ...this.formData, ...data };
                } else if (index >= 2) {
                    // For the simplified flow, we save after step 3 (or any step >= 2 for dynamic forms)
                    console.log('🏠 About to save venture - formData:', this.formData);
                    const ventureParam = {
                        name:
                            this.formData?.description?.substring(0, 50) +
                            "...",
                        description: this.formData?.description,
                        users: {
                            connect: [{ id: this.state.currentUser?.id }],
                        },
                        hypotheses: {
                            create: [
                                {
                                    name:
                                        "create " + this.formData?.description,
                                },
                            ],
                        },
                        targetCustomerUsers: {
                            create: [
                                {
                                    name: this.formData?.description,
                                    researchPrompt:
                                        this.formData?.reasonSecond?.label ||
                                        "learn about their experiences",
                                    emailTemplates: {
                                        create: c.emailTemplates,
                                    },
                                    interviewScripts: {
                                        create: [
                                            {
                                                ...c.interviewScript,
                                                createdBy: {
                                                    connect: {
                                                        id: this.state
                                                            .currentUser?.id,
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    targetCustomer: {
                                        create: {
                                            name: lowerFirst(
                                                this.formData?.description
                                            ),
                                            type: "INDIVIDUALS",
                                        },
                                    },
                                    createdBy: {
                                        connect: {
                                            id: this.state.currentUser?.id,
                                        },
                                    },
                                },
                            ],
                        },
                        opportunities: {
                            create: [
                                {
                                    type: "ACTIVITY",
                                    name: "",
                                    desireText:
                                        this.formData?.reasonFirst?.value,
                                    problemContext: this.formData?.reasonFour,
                                    problems: { connect: [], create: [] },
                                },
                            ],
                        },
                        createdBy: {
                            connect: { id: this.state.currentUser?.id },
                        },
                    };

                    console.log(ventureParam, "param");
                    response = await this.actions.saveFormData({
                        mutation: "saveVenture",
                        params: ventureParam,
                    });

                    const ventures = await this.actions.venture.getVentures({
                        where: { id: response?.id },
                        getValues: true,
                        query: "ventureDetail",
                    });

                    console.log(ventures, "ventures");
                    response = ventures?.[0];

                    // Add Member and Advisor groups
                    const groups = [
                        {
                            name: "Member",
                            description: "Member",
                            isArchive: false,
                            venture: { connect: { id: response?.id } },
                            type: "ROLE",
                            permissions: {
                                create: [
                                    {
                                        type: "data",
                                        name: "Manage Venture",
                                        description: "Venture management",
                                        collection: {
                                            create: {
                                                name: "Venture",
                                            },
                                        },
                                        access: {
                                            create: {
                                                delete: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: true,
                                                    },
                                                },
                                                read: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: false,
                                                    },
                                                },
                                                create: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: true,
                                                    },
                                                },
                                                update: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: false,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                ],
                            },
                        },
                        {
                            name: "Advisor",
                            description: "Advisor",
                            isArchive: false,
                            venture: { connect: { id: response?.id } },
                            type: "ROLE",
                            permissions: {
                                create: [
                                    {
                                        type: "data",
                                        name: "Manage Ventures",
                                        description: "Venture management",
                                        collection: {
                                            create: {
                                                name: "Venture",
                                            },
                                        },
                                        access: {
                                            create: {
                                                delete: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: true,
                                                    },
                                                },
                                                read: {
                                                    create: {
                                                        access: true,
                                                        mustOwn: false,
                                                    },
                                                },
                                                create: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: true,
                                                    },
                                                },
                                                update: {
                                                    create: {
                                                        access: false,
                                                        mustOwn: false,
                                                    },
                                                },
                                            },
                                        },
                                    },
                                ],
                            },
                        },
                    ];

                    groups.map(
                        async (g) =>
                            await this.actions.group.saveGroup({
                                data: g,
                            })
                    );

                    if (
                        this.state.currentUser?.userGroups?.find(
                            (u) => u?.group?.name === "ecosystem-user"
                        )
                    ) {
                        await this.actions.company.saveCompany({
                            where: {
                                id: this.state.currentUser?.companies?.[0]?.id,
                            },
                            data: {
                                ventures: { connect: [{ id: response?.id }] },
                            },
                        });
                        await this.actions.user.saveUser({
                            where: { id: this.state.currentUser?.id },
                            data: {
                                metadata: {
                                    ...this.state.currentUser?.metadata,
                                    showEcosystemModal: false,
                                    firstLogin: false,
                                },
                            },
                        });
                    }

                    if (this.state.currentUser?.metadata?.showCohortModal) {
                        await this.actions.venture.addVentureTo({
                            userId: this.state.currentUser?.id,
                            ventureId: response?.id,
                            cohortId:
                                this.state.currentUser?.metadata
                                    ?.recentlyInvitedCohortId,
                        });
                    }

                    this.isShowIdea = false;
                    
                    console.log('🏠 About to check redirect - index:', index, 'response.id:', response.id);
                    
                    // Check if this is the Summary step by looking at the form data
                    // The Summary step should have specific characteristics that identify it
                    const isSummaryStep = data && (
                        data.description && 
                        data.reasonFirst && 
                        data.reasonSecond && 
                        data.reasonThird && 
                        data.reasonFour
                    );
                    
                    console.log('🚀 Checking if Summary step - data keys:', Object.keys(data));
                    console.log('🚀 Is Summary step based on data?', isSummaryStep);
                    
                    if (isSummaryStep) {
                        console.log('🚀 Summary step - NOT redirecting, staying on current view');
                        console.log('🚀 Venture saved successfully, ready for Opportunity Map');
                        // TODO: Redirect to Opportunity Map view when it's ready
                        // this.$router.push({ name: "Opportunity Map", params: { ventureId: response.id } });
                    } else {
                        console.log('🚀 Not Summary step - redirecting to Venture Dashboard');
                        this.$router.push({
                            name: "Venture Dashboard",
                            params: { ventureId: response.id },
                        });
                    }
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.isSaving = false;
            }
        },
        getCompanies() {
            this.companies = this.state.currentUser?.companies?.map(
                (company) => {
                    let cohorts = 0;
                    company?.programs?.map(
                        (p) => (cohorts += p?.cohorts?.length)
                    );
                    return {
                        id: company?.id,
                        title: company?.name,
                        description: company?.description,
                        subtitles: [
                            {
                                icon: "LightBulbIcon",
                                name: "Ventures",
                                count: company?.ventures?.length,
                            },
                            {
                                icon: "NewspaperIcon",
                                name: "Programs",
                                count: company?.programs?.length,
                            },
                            {
                                icon: "UsersIcon",
                                name: "Cohorts",
                                count: cohorts,
                            },
                        ],
                    };
                }
            );
        },
        async getResourcesData() {
            await this.actions.resource.getResources({
                orderBy: "createdAt_DESC",
                first: 2,
            });
            this.resources = _.map(
                this.state.resource.resources,
                (resource) => {
                    return {
                        id: resource.id,
                        title: resource?.name || "",
                        desc: resource?.description || "",
                        items: [{ label: resource?.type }],
                    };
                }
            );
            this.isLoading = false;
        },
        async getVenturesData() {
            await this.actions.venture.getVentures({
                orderBy: "createdAt_DESC",
                first: 2,
                where: {
                    users_some: {
                        id: this.state.currentUser?.id,
                    },
                },
                query: "venturesList",
            });
            await this.actions.venture.getTotalVentures();
            console.log(this.state.venture.ventures, "ventures");
            await this.actions.milestone.getMilestones();
            Object.values(this.state.venture.ventures)?.map((venture) => {
                const currentMilestone = json(venture?.milestones)?.sort(
                    (a, b) => (a?.sortOrder > b?.sortOrder ? -1 : 1)
                )?.[0];
                this.ventures.push({
                    id: venture.id,
                    title: venture?.name || "",
                    description: venture?.description || "",
                    actionLabel:
                        currentMilestone?.tagLabel || "Getting Started",
                    subtitles: [
                        {
                            icon: "MapIcon",
                            name: "Target Customers",
                            count: venture?.targetCustomerUsers?.filter(
                                (t) => !t?.isArchived
                            )?.length,
                        },
                        {
                            icon: "ExclamationIcon",
                            name: "Opportunities",
                            count: venture?.opportunities?.filter(
                                (o) => !o?.isArchived
                            ).length,
                        },
                        {
                            icon: "UsersIcon",
                            name: "Team",
                            count: venture?.users?.length,
                        },
                    ],
                });
            });
        },
        async onCloseWelcome(isYes) {
            try {
                this.isShow = false;
                if (isYes) {
                    this.isShowIdea = true;
                }
                if (this.state.currentUser?.metadata?.showVentureAlert) {
                    this.isShowVenture = true;
                }
                await this.actions.user.saveUser({
                    where: { id: this.state.currentUser?.id },
                    data: {
                        metadata: {
                            ...this.state.currentUser?.metadata,
                            firstLogin: false,
                        },
                    },
                });
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>
